<template>
	<modal
		:max-width="'50%'"
		:max-height="'30%'"
		:exibir="exibir"
		:titulo="'Baixar Anexos'"
		@close="fecharModal"
		:custom-actions="true"
	>
		<template #body>
			<v-row class="pt-5">
				<div v-for="{ id, idExterno, nome } in datasource" :key="id" class="ma-2">
					<v-chip style="cursor: pointer" color="grey lighten-3" label @click="baixarAnexo(idExterno)">
						<texto-tooltip :texto="nome" :tamanho-maximo="20"></texto-tooltip>
					</v-chip>
				</div>
			</v-row>
		</template>
	</modal>
</template>
<script>
import { actionTypes } from '@/core/constants'
import TextoTooltip from '@/views/components/TextoTooltip.vue'
import Modal from '@/views/components/Modal.vue'

export default {
	name: 'modal-baixar-anexo-fiscal',
	components: { Modal, TextoTooltip },
	props: {
		exibir: Boolean,
		idFiscal: {
			type: Number,
			default: null,
		},
	},
	emits: ['fechar-modal'],
	data() {
		return {
			datasource: [],
		}
	},
	async mounted() {
		if (this.idFiscal) {
			this.datasource = await this.$store.dispatch(actionTypes.CONFIGURACAO.FISCAIS.BUSCAR_ANEXOS, {
				idFiscal: this.idFiscal,
			})
		}
	},
	methods: {
		fecharModal() {
			this.$emit('fechar-modal')
		},
		async baixarAnexo(idExterno) {
			await this.$store.dispatch(actionTypes.CONFIGURACAO.FISCAIS.BAIXAR_ANEXO, {
				idFiscal: this.idFiscal,
				idExterno,
			})
			this.mostrarNotificacaoSucessoDefault()
		},
	},
}
</script>
